import { useEffect, useRef } from 'react';

/**
 * Listen to inventory_updated domain events with payload detail.
 * @param {(detail: object) => void} handler
 * @param {unknown[]} [deps]
 */
export function useDomainInventoryListener(handler, deps = []) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  const depsKey = JSON.stringify(deps);

  useEffect(() => {
    const onDomainEvent = (event) => {
      if (event?.detail?.type !== 'inventory_updated') return;
      handlerRef.current?.(event.detail.payload || {});
    };

    window.addEventListener('elkheir:domain-event', onDomainEvent);
    return () => window.removeEventListener('elkheir:domain-event', onDomainEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depsKey]);
}

/**
 * Listen to worker_session_updated / ecart_updated domain events.
 * @param {{ onWorkerSession?: (detail: object) => void, onEcart?: (detail: object) => void }} handlers
 * @param {unknown[]} [deps]
 */
export function useDomainOperationsListener(handlers, deps = []) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;
  const depsKey = JSON.stringify(deps);

  useEffect(() => {
    const onDomainEvent = (event) => {
      const type = event?.detail?.type;
      const payload = event?.detail?.payload || {};
      if (type === 'worker_session_updated') {
        handlersRef.current?.onWorkerSession?.(payload);
      } else if (type === 'ecart_updated') {
        handlersRef.current?.onEcart?.(payload);
      } else if (type === 'deviation_notification') {
        handlersRef.current?.onDeviationNotification?.(payload);
      }
    };

    window.addEventListener('elkheir:domain-event', onDomainEvent);
    return () => window.removeEventListener('elkheir:domain-event', onDomainEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depsKey]);
}
